// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabPanel_tab__3H98_"};